import {ExternalVideoType, VideoContainer} from '../@types';
import {EXTERNAL_HOSTINGS}                 from './hostings';

const safeParseUrl = (url: string): URL | null => {
    try {
        return new URL(url);
    } catch (e) {
        return null;
    }
};

const EXTERNAL_VIDEO_TYPES = Object.keys(EXTERNAL_HOSTINGS) as ExternalVideoType[];

const normalizeHost = (host: string): string =>
    host.toLowerCase().replace(/^(www|m)\./, '')
;

const detectExternalVideoType = (url: URL): ExternalVideoType | null => {
    const host         = normalizeHost(url.hostname);
    const detectedType = EXTERNAL_VIDEO_TYPES.find(
        type => EXTERNAL_HOSTINGS[type].hosts.some(
            h => normalizeHost(h) === host
        )
    );

    return detectedType ?? null;
};


export const isExternalVideoType = (type: string): type is ExternalVideoType =>
    EXTERNAL_VIDEO_TYPES.some(externalType => externalType === type)
;

export const getVideoType = ({type, url}: VideoContainer): VideoContainer['type'] => {
    const canDetect    = type === 'unknown' || type === 'direct';
    const parsedUrl    = canDetect ? safeParseUrl(url) : null;
    const detectedType = parsedUrl ? detectExternalVideoType(parsedUrl) : null;

    return detectedType ?? type;
};

export const getEmbedUrl = (type: ExternalVideoType, url: string): string | null => {
    const parsed       = safeParseUrl(url);
    const isHostOfType = !!parsed && detectExternalVideoType(parsed) === type;

    return isHostOfType
        ? EXTERNAL_HOSTINGS[type].toEmbed(parsed)
        : null
    ;
};
